var map = {
	"./bca.jpg": 295,
	"./bni.jpg": 296,
	"./bri.jpg": 297,
	"./cimb.jpg": 298,
	"./danamon.jpg": 299,
	"./hana.jpg": 300,
	"./mandiri.jpg": 301,
	"./nologo.jpg": 156,
	"./permata.jpg": 302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;